<template>
  <div class="wg-row">
    <div class="vertical-height-div" style="height:10px;"></div>
    <w-g-list
        :pagination="false"
        :fieldInit="field"
        :directionInit="direction"
        :keyField="'id'"
        :sortingFunctionGenerator="sortingFunctionGenerator"
        :headerItems="headerItems"
        :itemsToDisplay="tableItems"
        @sorting-field-changed="sortingFieldChanged"
        @direction-changed="directionChanged"
    >
      <template v-slot:default="{element}">
        <project-bar 
          :projectData="element" 
          :view="'full'"
        ></project-bar>
      </template>
    </w-g-list>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import WGList from '../../../../../world/spa/components/WGList.vue';
import ProjectBar from '../project/ProjectBar.vue';

export default {
  components: {
    WGList,
    ProjectBar
  },
  props: {
    // Array di info aggregate
    projectsData: {
      type: Array,
      default: () => [],
    },
    sortingFunctionGenerator: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      field: this.$anm22.getCookie('tk_p_col') !== '' ? this.$anm22.getCookie('tk_p_col') : "deadline",
      direction: this.$anm22.getCookie('tk_p_dir') !== '' ? this.$anm22.getCookie('tk_p_dir') : "DESC",
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    headerItems() {
      return [
        {
          field: 'projectId',
          label: this.$anm22.strLang(this.lang, 'Code', 'Codice'),
          class: 'wg-xs-none wg-sm-2',
          // style: {justifyContent: 'center'},
          disabled: false,
        },
        {
          field: 'name',
          label: this.$anm22.strLang(this.lang, 'Name', 'Nome'),
          class: 'wg-xs-none wg-sm-3',
          // style: {justifyContent: 'center'},
          disabled: false,
        },
        {
          field: 'codeName',
          label: this.$anm22.strLang(this.lang, 'Name', 'Nome'),
          class: 'wg-xs-7 wg-sm-none',
          // style: {justifyContent: 'center'},
          disabled: false,
        },
        {
          field: 'staff',
          label: this.$anm22.strLang(this.lang, 'Staff', 'Staff'),
          class: 'wg-xs-2',
          // style: {justifyContent: 'center'},
          disabled: true,
        },
        {
          field: 'status',
          label: this.$anm22.strLang(this.lang, 'Status', 'Stato'),
          class: 'wg-xs-none wg-sm-1',
          style: {justifyContent: 'center'},
          disabled: false,
        },
        {
          field: 'startDate',
          label: this.$anm22.strLang(this.lang, 'Start', 'Inizio'),
          class: 'wg-xs-none wg-sm-2',
          style: {justifyContent: 'center'},
          disabled: false,
        },
        {
          field: 'deadline',
          label: this.$anm22.strLang(this.lang, 'Deadline', 'Scadenza'),
          class: 'wg-xs-3 wg-sm-2',
          style: {justifyContent: 'center'},
          disabled: false,
        },
      ];
    },
    tableItems() {
      return this.projectsData.map(pdata => {
        return {
          ...pdata,
          'list-metadata': {
            type: 'item',
          }
        }
      });
    }
  },
  methods: {
    sortingFieldChanged(field) {
      this.$anm22.setCookie('tk_p_col', field, 31536000);
    },
    directionChanged(direction) {
      this.$anm22.setCookie('tk_p_dir', direction, 31536000);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>